var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("商品属性库")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "box" },
      [
        _c(
          "div",
          { staticClass: "el-menu-input" },
          [
            _vm._m(1),
            _c("el-input", {
              attrs: { placeholder: "输入关键字进行过滤" },
              model: {
                value: _vm.filterText,
                callback: function ($$v) {
                  _vm.filterText = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "filterText",
              },
            }),
            _c("el-tree", {
              ref: "tree",
              staticClass: "filter-tree",
              staticStyle: { height: "100px", "overflow-y": "auto" },
              attrs: {
                data: _vm.categoryOptions,
                props: {
                  label: "categoryName",
                  value: "id",
                },
                "highlight-current": true,
                "filter-node-method": _vm.filterNode,
              },
              on: { "node-click": _vm.handleNodeClick },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "inquiryTab" }, [
          _c("div", { staticClass: "titleBox" }, [
            _c("div", { staticClass: "left_title" }, [
              _vm.categoryName.length == 3
                ? _c("span", [
                    _vm._v(" 已选择："),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#333333", "font-size": "16px" },
                      },
                      [
                        _vm._v(_vm._s(_vm.categoryName[0])),
                        _vm.categoryName[1]
                          ? _c("span", [_vm._v(">")])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.categoryName[1])),
                        _vm.categoryName[2]
                          ? _c("span", [_vm._v(">")])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.categoryName[2])),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#999999", "font-size": "16px" },
                      },
                      [
                        _vm._v(
                          "(共" +
                            _vm._s(_vm.categoryLength) +
                            "个属性组" +
                            _vm._s(_vm.categoryNum) +
                            "个属性)"
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
            _c(
              "div",
              [
                _vm.parArray.indexOf("addAttributeSet") != -1
                  ? _c(
                      "el-button",
                      {
                        staticStyle: {
                          width: "120px",
                          height: "36px",
                          "line-height": "10px",
                        },
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addAttributeset("addAttributeset")
                          },
                        },
                      },
                      [_vm._v("新增属性组")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "table" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    border: "",
                    "header-cell-style": { background: "#f8f8f8" },
                    data: _vm.tableData,
                    align: "center",
                    "span-method": _vm.objectSpanMethod,
                    "row-class-name": _vm.tableRowClassName,
                  },
                  on: {
                    "cell-mouse-enter": _vm.cellMouseEnter,
                    "cell-mouse-leave": _vm.cellMouseLeave,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", label: "序号", width: "60" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "属性组名", prop: "propName" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [_vm._v(_vm._s(props.row.propName))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "属性名称", prop: "name" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [_vm._v(_vm._s(props.row.name))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "类型", prop: "typeFlagLabel" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "必填", prop: "requiredFlagLabel" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "关键属性", prop: "mainFlagLabel" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "属性值", prop: "itemLabels" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [_vm._v(_vm._s(props.row.itemLabels))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", prop: "statusLabel", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c(
                              "p",
                              {
                                style:
                                  props.row.status == "1"
                                    ? "color:#67C23A"
                                    : "color:#F56C6C",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(props.row.statusLabel) + " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "属性操作", width: "190" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            props.row.firstFlag == 0 &&
                            _vm.parArray.indexOf("propertymove") != -1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.propertyMoveup(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v("上移" + _vm._s(props.index))]
                                )
                              : _vm._e(),
                            props.row.lastFlag == 0 &&
                            _vm.parArray.indexOf("propertydown") != -1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.propertyMovedown(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v("下移")]
                                )
                              : _vm._e(),
                            _vm.parArray.indexOf("propertyedit") != -1 &&
                            props.row.id
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.propertyEdit(
                                          "propertyEdit",
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                )
                              : _vm._e(),
                            _vm.parArray.indexOf("propertydelete") != -1 &&
                            props.row.id
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#f56c6c" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.categoryDelete(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "属性组操作", width: "250" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            props.row.groupfirst == 0 &&
                            _vm.parArray.indexOf("moveAttributeset") != -1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.attributesetMoveup(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v("上移")]
                                )
                              : _vm._e(),
                            props.row.grouplast == 0 &&
                            _vm.parArray.indexOf("downAttributeSet") != -1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.attributesetMovedown(
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("下移")]
                                )
                              : _vm._e(),
                            _vm.parArray.indexOf("addproperty") != -1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.propertyEdit(
                                          "add",
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("添加属性")]
                                )
                              : _vm._e(),
                            _vm.parArray.indexOf("editAttributeSet") != -1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addAttributeset(
                                          "edit",
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                )
                              : _vm._e(),
                            _vm.parArray.indexOf("deleteAttributeSet") != -1
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#f56c6c" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.categoryGroupDelete(
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.dialog.title,
              visible: _vm.dialog.visible,
              width: _vm.dialog.width,
              "before-close": _vm.handleClose,
              "append-to-body": "",
            },
            on: {
              "update:visible": function ($event) {
                return _vm.$set(_vm.dialog, "visible", $event)
              },
            },
          },
          [
            _vm.dialog.type == "propertyEdit" || _vm.dialog.type == "add"
              ? [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "属性名称",
                            prop: "name",
                            "label-width": "85px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入属性名称",
                              maxlength: 20,
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.ruleForm.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "ruleForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "属性类型",
                            prop: "typeFlag",
                            "label-width": "85px",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder:
                                  "商品维护时内容录入方式：当选中项为单选、复选时需要填写对应属性值",
                              },
                              on: { change: _vm.hangleTypeFlag },
                              model: {
                                value: _vm.ruleForm.typeFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "typeFlag", $$v)
                                },
                                expression: "ruleForm.typeFlag",
                              },
                            },
                            _vm._l(
                              _vm.dictionaries.goods_attr_type,
                              function (item) {
                                return _c("el-option", {
                                  key: item.dictId,
                                  attrs: {
                                    label: item.dictName,
                                    value: item.dictId,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "必填",
                            prop: "requiredFlag",
                            "label-width": "85px",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { "margin-left": "4px" },
                              model: {
                                value: _vm.ruleForm.requiredFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "requiredFlag", $$v)
                                },
                                expression: "ruleForm.requiredFlag",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("是"),
                              ]),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "margin-left": "20px" },
                                  attrs: { label: "0" },
                                },
                                [_vm._v("否")]
                              ),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "hint" }, [
                            _vm._v("商品维护时内容是否必填"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "关键属性",
                            prop: "mainFlag",
                            "label-width": "85px",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { "margin-left": "4px" },
                              model: {
                                value: _vm.ruleForm.mainFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "mainFlag", $$v)
                                },
                                expression: "ruleForm.mainFlag",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("是"),
                              ]),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "margin-left": "20px" },
                                  attrs: { label: "0" },
                                },
                                [_vm._v("否")]
                              ),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "hint" }, [
                            _vm._v("当前属性是否关键属性"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "状态",
                            prop: "status",
                            "label-width": "85px",
                          },
                        },
                        _vm._l(_vm.dictionaries.enable_status, function (item) {
                          return _c(
                            "el-radio-group",
                            {
                              key: item.dictId,
                              model: {
                                value: _vm.ruleForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "status", $$v)
                                },
                                expression: "ruleForm.status",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: {
                                    "padding-right": "19px",
                                    "padding-left": "4px",
                                  },
                                  attrs: { label: item.dictId },
                                },
                                [_vm._v(_vm._s(item.dictName))]
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "备注",
                            prop: "remark",
                            "label-width": "85px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入内容",
                              maxlength: 200,
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.ruleForm.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "remark", $$v)
                              },
                              expression: "ruleForm.remark",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.TypeFlagValue != 1 && _vm.TypeFlagValue != 4
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "属性值",
                                prop: _vm.propertyDataState,
                                "label-width": "85px",
                              },
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  staticClass: "dialogTabel",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.ruleForm.propertyData,
                                    "header-cell-style": {
                                      background: "#f8f8f8",
                                      fontSize: "14px",
                                      color: "#606266",
                                    },
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "index",
                                      label: "序号",
                                      width: "70",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "属性值", prop: "label" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (props) {
                                            return [
                                              _c("el-input", {
                                                ref: "addPropertyInput",
                                                attrs: {
                                                  placeholder: "请输入内容",
                                                },
                                                nativeOn: {
                                                  keyup: function ($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      $event.keyCode !== 13
                                                    )
                                                      return null
                                                    return _vm.addProperty(
                                                      props.$index
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: props.row.label,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      props.row,
                                                      "label",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression: "props.row.label",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1087330293
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "属性操作", prop: "name" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.upMove(
                                                        scope.$index,
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("上移")]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.upDown(
                                                        scope.$index,
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("下移")]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    color: "#f56c6c",
                                                  },
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.rowDelete(
                                                        scope.$index,
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2191358814
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "addProperty" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-plus",
                                      },
                                      on: { click: _vm.addProperty },
                                    },
                                    [_vm._v("新增")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialog.visible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submit("ruleForm")
                            },
                          },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm.dialog.type == "addAttributeset" || _vm.dialog.type == "edit"
              ? [
                  _c(
                    "el-form",
                    {
                      ref: "propertyForm",
                      attrs: {
                        model: _vm.propertyForm,
                        rules: _vm.addRules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "属性组名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入属性组名称",
                              maxlength: 20,
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.propertyForm.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.propertyForm,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "propertyForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "所属类目", prop: "categoryId" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择三级类目",
                              disabled: _vm.categoryState,
                              options: _vm.categoryOptions,
                              props: {
                                label: "categoryName",
                                value: "id",
                                checkStrictly: true,
                              },
                              filterable: "",
                              clearable: "",
                            },
                            on: { change: _vm.handleCategory },
                            model: {
                              value: _vm.propertyForm.categoryId,
                              callback: function ($$v) {
                                _vm.$set(_vm.propertyForm, "categoryId", $$v)
                              },
                              expression: "propertyForm.categoryId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "attributeSet" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "cancel",
                              on: {
                                click: function ($event) {
                                  _vm.dialog.visible = false
                                },
                              },
                            },
                            [_vm._v("取 消")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "confirm",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.attributesetSubmit("propertyForm")
                                },
                              },
                            },
                            [_vm._v("确 定")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
        _c(
          "el-dialog",
          {
            staticClass: "deletegroup",
            attrs: {
              title: "删除属性组",
              visible: _vm.dialogVisible,
              width: "520px",
              "before-close": _vm.handledeleteClose,
              "append-to-body": "",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header-title",
                staticStyle: { display: "flex", "align-items": "center" },
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "span",
                  { staticStyle: { "font-size": "28px", color: "red" } },
                  [_c("i", { staticClass: "el-icon-warning" })]
                ),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "padding-left": "12px",
                      "font-size": "22px",
                    },
                  },
                  [_vm._v("删除属性组")]
                ),
              ]
            ),
            _c(
              "span",
              { staticStyle: { "font-size": "16px", color: "#333333" } },
              [_vm._v("此操作将删除选中属性组，是否继续？")]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "12px",
                  color: "#999999",
                  "padding-top": "5px",
                },
              },
              [_vm._v(" 注：属性组内所包含的属性页一并删除 ")]
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "120px",
                      height: "36px",
                      border: "1px solid #d9d9d9",
                      opacity: "1",
                      "line-height": "2px",
                      "border-radius": "4px",
                    },
                    on: {
                      click: function ($event) {
                        _vm.dialogVisible = false
                      },
                    },
                  },
                  [_vm._v("取 消")]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "120px",
                      height: "36px",
                      "line-height": "2px",
                      opacity: "1",
                      "border-radius": "4px",
                    },
                    attrs: { type: "primary" },
                    on: { click: _vm.deleteGroup },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headerbox" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title_left" }),
        _vm._v(" 商品属性库 "),
      ]),
      _c("div", { staticClass: "headerbox_right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "titleBox" }, [
      _c("div", { staticStyle: { display: "flex", "align-items": "center" } }, [
        _c("div", { staticClass: "left_title" }, [_vm._v("选择类目")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }